import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UserRecentCreate, UserRecents } from '@thiememeulenhoff/types';
import { UserRecentEndpointService } from './user-recent.endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class UserRecentService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(UserRecentEndpointService);

  createRecentMethod(recent: UserRecentCreate) {
    const endpoint = this.#endpoints.createRecentMethod();

    return this.#http.post<UserRecents>(endpoint, recent);
  }

  createRecentArrangement(methodSlug: string, recent: UserRecentCreate) {
    const endpoint = this.#endpoints.createRecentArrangement(methodSlug);

    return this.#http.post<UserRecents>(endpoint, recent);
  }

  createRecentResource(arrangementCode: string, recent: UserRecentCreate) {
    const endpoint = this.#endpoints.createRecentResource(arrangementCode);

    return this.#http.post<UserRecents>(endpoint, recent);
  }

  removeAllRecents() {
    const endpoint = this.#endpoints.removeRecents();

    return this.#http.delete(endpoint);
  }
}
